<template>
<div class='odp_mod_line'>
	<div class='odp_mod_li_name font-14'>{{lineData['name']}}：</div>
	<div class='odp_mod_li_right font-14'>

		<template v-for="(item,index) in lineData['data_after']">

			<div v-if="item['data']" 
				 :key='item.id' 
				 :class="{'odp_mod_li_rig_inline':true, 'odp_mod_li_rig_inline_minwidth':!item.reduce}" 
				 >

				 <template v-for="(obj,seq) in item['data']">
					<!-- 下拉块 -->
					<div v-if="obj.type==='select'" 
						:class="{'odp_mod_li_rig_select':true}" 
						:key='obj.id' 
						:data-index='index' 
						:data-seq='seq' 
						@mouseenter="func_vData_selectEnter" 
						@mouseleave="func_vData_selectLeave" 
						@click="func_vData_selectEnter" 
						>
						<div :class="{'odp_mod_li_rig_sel_content':true, 'odp_mod_li_rig_isChoose':obj.choose}" 
							 data-type='data_after' 
							:data-index='lineIndex' 
							:data-seq='index' 
							:data-se='seq' 
							@click.stop='func_vData_select_click' 
							>
							<div class='odp_mod_li_rig_sel_con_name'>{{obj.name}}</div>
							<input v-if="obj.custom2 && obj.choose" class='odp_mod_li_rig_sel_con_input' @click.stop='func_null' v-model='obj.value[0]' @blur='func_input' />
							<div v-if="obj.custom2 && obj.choose">*</div>
							<input v-if="obj.custom2 && obj.choose" class='odp_mod_li_rig_sel_con_input' @click.stop='func_null' v-model='obj.value[1]' @blur='func_input' />
							<div v-if="obj.unit && obj.choose">{{obj.unit}}</div>
							<img :class="{'odp_mod_li_rig_sel_con_icon':true, 'odp_mod_li_rig_sel_con_icon_rotate':obj.select_show}" src='@/assets/icon/arrow_down.png' />
						</div>
						<div class='odp_mod_li_rig_list'>
							<template v-for='(temp,i) in obj.select_data'>
								<div :class="{'odp_mod_li_rig_li_view':true, 'odp_mod_li_rig_li_view_show':obj.select_show}" 
									:key='temp.id' 
									data-type='data_after' 
									:data-index='lineIndex' 
									:data-seq='index' 
									:data-se='seq' 
									:data-select_index='i' 
									@click.stop='func_vData_select_click' 
									>{{temp.name}}
								</div>
							</template>
						</div>
					</div>
					<!-- 普通块 -->
					<div v-if="obj.type==='default'" 
						 :class="{'odp_mod_li_rig_view':true, 'odp_mod_li_rig_isChoose':obj.choose}" 
						 :key='obj.id' 
						  data-type='data_after' 
						 :data-index='lineIndex' 
						 :data-seq='index' 
						 :data-se='seq' 
						 @click='func_click' 
						 >{{obj.name}}
					</div>
					<!-- 自定义输入块-1个 -->
					<div v-else-if="obj.type==='custom1' && (typeof obj.value!=='object') " 
						 :class="{'odp_mod_li_rig_custom':true, 'odp_mod_li_rig_isChoose':obj.choose}" 
						 :key='obj.id' 
						  data-type='data_after' 
						 :data-index='lineIndex' 
						 :data-seq='index' 
						 :data-se='seq' 
						 @click='func_click' 
						 >
						 <div class='odp_mod_li_rig_cust_name'>{{obj.name ? obj.name : '自定义'}}</div>
						 <input v-if='obj.choose' class='odp_mod_li_rig_cust_input' style='margin-bottom:0;' v-model='obj.value' @click.stop='func_null' @blur='func_input' />
					</div>
					<!-- 自定义输入块-2个 -->
					<div v-else-if="obj.type==='custom2'" 
						 :class="{'odp_mod_li_rig_custom':true, 'odp_mod_li_rig_isChoose':obj.choose}" 
						 :key='obj.id' 
						  data-type='data_after' 
						 :data-index='lineIndex' 
						 :data-seq='index' 
						 :data-se='seq' 
						 @click='func_click' 
						 >
						 <div class='odp_mod_li_rig_cust_name'>{{obj.name ? obj.name : '自定义'}}</div>
						 <template v-if='obj.choose'>
							<input class='odp_mod_li_rig_cust_input' v-model='obj.value[0]' style='margin-bottom:0;' @click.stop='func_null' @blur='func_input' />
							<div>*</div>
							<input class='odp_mod_li_rig_cust_input' v-model='obj.value[1]' style='margin-bottom:0;' @click.stop='func_null' @blur='func_input' />
						 </template>
					</div>
					<!-- 自定义输入块-4个 -->
					<div v-else-if="obj.type==='custom4'" 
						 :class="{'odp_mod_li_rig_custom':true, 'odp_mod_li_rig_isChoose':obj.choose}" 
						 :key='obj.id' 
						  data-type='data_after' 
						 :data-index='lineIndex' 
						 :data-seq='index' 
						 :data-se='seq' 
						 @click='func_click' 
						 >
						 <div class='odp_mod_li_rig_cust_name'>{{obj.name ? obj.name : '自定义'}}</div>
						 <template v-if='obj.choose'>
							<input class='odp_mod_li_rig_cust_input' v-model='obj.value[0]' style='margin-bottom:0;' @click.stop='func_null' @blur='func_input' />
							<div>*</div>
							<input class='odp_mod_li_rig_cust_input' v-model='obj.value[1]' style='margin-bottom:0;' @click.stop='func_null' @blur='func_input' />
							<div>mm</div>
							<input class='odp_mod_li_rig_cust_input' v-model='obj.value[2]' style='margin-bottom:0;' @click.stop='func_null' @blur='func_input' />
							<div>道</div>
						 </template>
					</div>
					<!-- 自定义输入块-1个 特殊结构 -->
					<div v-else-if="obj.type==='custom1' && obj.value.constructor['name']==='Array' " 
						 :class="{'odp_mod_li_rig_custom':true, 'odp_mod_li_rig_isChoose':obj.choose}" 
						 :key='obj.id' 
						  data-type='data_after' 
						 :data-index='lineIndex' 
						 :data-seq='index' 
						 :data-se='seq' 
						 @click='func_click' 
						 >
						 <div class='odp_mod_li_rig_cust_name'>{{obj.name ? obj.name : '自定义'}}</div>
						 <input v-if='obj.choose' class='odp_mod_li_rig_cust_input' style='margin-bottom:0;' v-model='obj.value[0]' @click.stop='func_null' @blur='func_input' />
						 {{obj.unit ? obj.unit : ''}}
					</div>
				 </template>

			</div>
			<div v-else :key='item.id' class='odp_mod_li_rig_inline_null'></div>

		</template>

	</div>

</div>
</template>
<script>

export default {
	name: 'vDataAfter',
	props: {
		lineIndex: String,
		lineData: Object,
		func_click: Function,
		func_input: Function
	},
	data() {
		return {
		}
	},
	methods: {
		func_vData_selectEnter() {
			const index = event.currentTarget.dataset.index;
			const seq = event.currentTarget.dataset.seq;
			this.lineData['data_after'][index]['data'][seq]['select_show'] = true;
		},
		func_vData_selectLeave() {
			const index = event.currentTarget.dataset.index;
			const seq = event.currentTarget.dataset.seq;
			this.lineData['data_after'][index]['data'][seq]['select_show'] = false;
		},
		func_vData_select_click(event) {
			const index = event.currentTarget.dataset.seq;
			const seq = event.currentTarget.dataset.se;
			this.lineData['data_after'][index]['data'][seq]['select_show'] = !this.lineData['data_after'][index]['data'][seq]['select_show'];
			/* if (!event.currentTarget.dataset.select_index && this.lineData['data_after'][index]['data'][seq]['choose']) {
				return;
			} */
			this.func_click(event);
		},
		func_null() {}
	},
	mounted() {
	}
}
</script>
<style src='@/style/orderProduct.css'></style>
<style src='@/style/orderProduct-h5.css'></style>



// WEBPACK FOOTER //
// src/pages/order/views/vDataAfter.vue